<script>
    import TextInput from './TextInput.vue';
    export default {
        mixins: [TextInput],
        data() {
            return {
                inputType: 'email'
            }
        }
    }
</script>